module.exports = __webpack_public_path__ + "static/logosOne.6970a6ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logosOne.png
// module id = ./src/assets/logosOne.png
// module chunks = 226020273838829